<div class="newsletter-floating-banner" *ngIf="showBanner">
    <button class="close-btn" (click)="cerrar()">×</button>
    
    <div class="content-layout" *ngIf="!success">
        <div class="text-side">
            <h2>¡Ofertas en tu correo!</h2>
            <p>Suscríbete y recibe promociones exclusivas.</p>
            
            <div class="form-row">
                <input type="email" [(ngModel)]="email" placeholder="Tu email" [disabled]="loading">
                <ui-button variant="primary" [disabled]="loading" (click)="suscribir()">
                    <span *ngIf="!loading">OK</span>
                    <span *ngIf="loading">...</span>
                </ui-button>
            </div>
            <span class="error-msg" *ngIf="error">{{error}}</span>
        </div>
    </div>

    <div class="success-banner" *ngIf="success">
        <h2>¡Listo! ✓</h2>
        <p>Gracias por suscribirte.</p>
    </div>
</div>
